import { render, staticRenderFns } from "./list-share-users.vue?vue&type=template&id=a4c767fa&scoped=true&"
import script from "./list-share-users.vue?vue&type=script&lang=ts&"
export * from "./list-share-users.vue?vue&type=script&lang=ts&"
import style0 from "./list-share-users.vue?vue&type=style&index=0&id=a4c767fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c767fa",
  null
  
)

export default component.exports